import { useClientPortalAPI, useSubmit } from "@certn/api";
import { components } from "@certn/api/generated-schemas/client-portal";
import { toastQueue } from "@certn/cascadia";
import { css } from "@emotion/css";
import { Key, useState } from "react";
import { useParams } from "react-router-dom";

import { AssignedGroupsList } from "../AssignedGroupsList";
import { RemoveGroupModal } from "../RemoveGroupModal";
import { UserGroupsSelect } from "../UserGroupsSelect";

export function UserGroupsTab() {
  const { userId } = useParams();
  const [groupToRemove, setGroupToRemove] = useState<
    components["schemas"]["UserCustomerGroupsListCustomerGroups"] | undefined
  >(undefined);
  const { data: user } = useClientPortalAPI(
    `/api/internal/client-portal/users/${userId}/`
  );
  const { data: groups, mutate: refreshUserGroups } = useClientPortalAPI(
    `/api/internal/client-portal/users/${userId}/customer-groups/`
  );
  const { submit: updateGroupsForUser } = useSubmit(
    `/api/internal/client-portal/users/${userId}/customer-groups/update/`,
    {
      throwErrors: true,
      showToastOnError: true,
      onSuccess: () => {
        const toasts = toastQueue.visibleToasts;
        if (toasts.length > 0) {
          // closes group removed success toast when undo has been selected
          toastQueue.close(toasts[0].key);
        }
        refreshUserGroups();
      },
    }
  );
  const userGroups = groups?.customer_groups || [];
  const onAdd = (selectedGroups: Key[]) => {
    updateGroupsForUser({ customer_groups_to_add: selectedGroups });
  };

  return (
    <div className={styles.container}>
      {!user?.is_auth0_blocked && (
        <UserGroupsSelect
          onDone={onAdd}
          userGroups={userGroups.map((group) => group.id)}
        />
      )}
      <AssignedGroupsList userGroups={userGroups} onRemove={setGroupToRemove} />
      <RemoveGroupModal
        isOpen={!!groupToRemove}
        userName={user?.name}
        group={groupToRemove}
        onCancel={() => {
          setGroupToRemove(undefined);
        }}
        refreshUserGroups={refreshUserGroups}
        undo={() =>
          updateGroupsForUser({ customer_groups_to_add: [groupToRemove?.id] })
        }
      />
    </div>
  );
}

const styles = {
  container: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-5)",
  }),
};
